<audio #audio>
</audio>

<div class="container p-3 h-100">
    <div class="row mat-elevation-z2 rounded p-4">
        <!-- PHONE SELECTION SECTION -->
        <div class="col-12 mb-5">
            <h1 class="mb-1">Set your Twilio phone number</h1>
        </div>

        <div class="row d-flex align-items-around">
            <div class="col-12 d-flex align-items-center justify-content-center">
            </div>

            <div class="col-12 d-flex align-items-center justify-content-center">
                <mat-form-field appearance="outline" class="w-50 m-1">
                    <mat-label>Phone number</mat-label>
                    <input matInput placeholder="(514)523-6687" [formControl]="phoneNumber" required readonly>
                    <mat-hint>Assistant twilio phone number</mat-hint>
                </mat-form-field>
            </div>

            <div class="row mt-4 justify-content-center">
                <button *ngIf="aiAgent.phoneSettings" type="button" mat-raised-button color="warn" class="w-25 me-4"
                    (click)="onRemoveClicked()">
                    Remove
                </button>
                <button type="button" mat-raised-button color="primary" class="w-25" (click)="onSelectClicked()">
                    Select
                </button>
            </div>
        </div>

        <mat-divider class="mt-5 mb-5"></mat-divider>
        <div class="row">
            <div class="col-12 mb-5">
                <h1 class="mb-1">Configure latency</h1>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col" *ngFor="let option of latencyOptions">
                        <div class="
                        mat-elevation-z2 
                        d-flex flex-column 
                        justify-content-around 
                        align-items-center 
                        rounded p-3"
                        [ngClass]="
                        {
                            'highlight-box': option.selected,
                        }" 
                        (click)="setChosenLatency(option.latencyConfig)">
                            <p style="font-size: 2em;">{{option.name}}</p>
                            <p style="font-size: 1em;"> {{option.latencyDescription}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <mat-divider class="mt-5 mb-5"></mat-divider>

        <!-- NAME AND VOICE SELECTION SECTION -->
        <form [formGroup]="assistantProfileForm" class="row">
            <div class="col-12 mb-3">
                <h1 class="mb-1">Set your assistant profile up</h1>
            </div>

            <div class="row mt-2">
                <div class="col-6">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Name</mat-label>
                        <input [readonly]="isAssistantProfileFormLoading" matInput placeholder="Placeholder" required
                            formControlName="name">
                        <mat-hint>Assistant name</mat-hint>
                    </mat-form-field>
                </div>

                <div class="col-6">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>
                            {{aiAgent.agentType == 'OUTBOUND' ? 'Pick one language':'Pick one language or multiple
                            languages'}}
                        </mat-label>
                        <mat-select formControlName="agentLanguages" *ngIf="aiAgent.agentType != 'OUTBOUND'" multiple>
                            <mat-option *ngFor="let lang of languages" class="mx-auto" [value]="lang">
                                {{lang.name}}
                            </mat-option>
                        </mat-select>
                        <mat-select formControlName="agentLanguages" *ngIf="aiAgent.agentType == 'OUTBOUND'">
                            <mat-option *ngFor="let lang of languages" class="mx-auto" [value]="lang">
                                {{lang.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="assistantProfileForm.controls['agentLanguages'].hasError('validLanguageVoiceProvider')">Only
                            OpenAi voices are multilingual, please select a voice from OpenAi</mat-error>
                        <mat-hint align="start">Pick one or multiple languages</mat-hint>
                    </mat-form-field>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-6 d-flex align-items-center">
                    <button type="button" [disabled]="isAssistantProfileFormLoading" mat-raised-button class="w-75 mb-4"
                        (click)="openVoiceSelectionDialog()">Select
                        assistant
                        voice</button>
                </div>

                <div class="col-6">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Voice Name</mat-label>
                        <input readonly matInput placeholder="Placeholder" required readonly
                            formControlName="chosenVoiceName">
                        <mat-hint>Assistant Voice</mat-hint>
                        <mat-error
                            *ngIf="assistantProfileForm.controls['agentLanguages'].hasError('validLanguageVoiceProvider')">Only
                            OpenAi, Cartesia and PlayHt voices are multilingual, please select a voice from one of those
                            providers</mat-error>
                        <mat-icon (click)="playVoice()"
                            *ngIf="assistantProfileForm.controls['sample'].value?.length != ''" style="cursor: pointer;"
                            matSuffix>{{isVoicePlaying ? 'stop'
                            :
                            'play_arrow' }}</mat-icon>
                    </mat-form-field>
                </div>
            </div>

            <app-eleven-labs-voice-settings *ngIf = "assistantProfileForm.get('voiceProvider')?.value === 'ELEVENLABS'" [assistantForm]="assistantProfileForm"></app-eleven-labs-voice-settings>
            <app-llm-choice [assistantForm]="assistantProfileForm"></app-llm-choice>
            <div class="row mt-2">
                <button (click)="f_input.click()" mat-raised-button type="button">
                    <span>Upload Intro Message</span>
                    <mat-icon>upload</mat-icon>
                </button>

                <input multiple hidden #f_input type="file" accept=".mp3,audio/mpeg"
                    (change)="handleFileInputChange(f_input.files!)">
            </div>

            <div *ngIf="this.aiAgent.introPlayback && this.aiAgent.introPlayback.length > 0" class="row mt-2">
                <div class="col-sm-10">
                    <audio controls class="w-100">
                        <source [src]="aiAgent.introPlayback" type="audio/mp3">
                        Your browser does not support the audio element.
                    </audio>
                </div>
                <div class="col-sm-2">
                    <button mat-raised-button (click)="onDeleteIntroMessage()" class="mt-2">
                        <span>Delete</span>
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>


            </div>

            <!-- Language and custom greeting -->
            <div class="row mt-4">
                <div class="col-9">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Custom greeting</mat-label>
                        <input [readonly]="isAssistantProfileFormLoading" class="mt-2" style="height: 30px;" matInput
                            placeholder="Ex: Hey there how can I assist you today" required formControlName="greeting">
                        <mat-hint>
                            The opening line for your assistant call.
                            {{aiAgent.agentType =='OUTBOUND' ? 'Add variables with curly brackets : {variable}':'' }}
                        </mat-hint>

                        <mat-error *ngIf="assistantProfileForm.controls['greeting'].hasError('minlength')">
                            Greeting should be over 5 characters
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-3">
                    <mat-checkbox formControlName="isNonInterruptibleMessage">Interuptible opening line </mat-checkbox>
                    <mat-checkbox formControlName="hangupAfterGreet">Hangup after greeting </mat-checkbox>
                </div>

            </div>

            <!-- Agent context configuration -->
            <div class="row mt-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Agent context</mat-label>
                    <textarea rows="5" formControlName="agentContext"
                        placeholder="You are a customer service agent working at a ice cream shop" matInput
                        required></textarea>
                    <mat-hint>
                        Give some context to the AI on its role, about the company he's working for,etc.
                        {{aiAgent.agentType =='OUTBOUND' ? 'Add variables with curly brackets : {variable}':'' }}
                    </mat-hint>


                </mat-form-field>
            </div>

            <div class="col-12 text-center mt-4">
                <button type="button" (click)="updateAssistantProfile()"
                    [disabled]="isAssistantProfileFormLoading || !assistantProfileForm.valid" class="w-25"
                    mat-raised-button>
                    <span *ngIf="!isAssistantProfileFormLoading">Save</span>

                    <mat-spinner *ngIf="isAssistantProfileFormLoading" [diameter]="30" [strokeWidth]="3"
                        class="mx-auto mat-spinner"></mat-spinner>
                </button>
            </div>
        </form>
    </div>




</div>